import React from 'react';
import './Summary.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMagnifyingGlass, faFilter } from '@fortawesome/free-solid-svg-icons';
import MonthRangePicker from '../summary/MonthRangePickerSummary';

export default function SummaryToolbar({ 
  value, 
  onChange, 
  onFilterClick, 
  filterRef,
  dateRange,
  onRangeChange 
}) {
  return (
    <div className="sum-toolbar">
      {/* Range Picker */}
      <div className="anl-inline sum-range-inline">
        <span className="anl-label">Range:</span>
        <MonthRangePicker
          value={dateRange}
          onChange={onRangeChange}
          placeholder="MM/YYYY – MM/YYYY"
        />
      </div>

      {/* Search Input */}
      <div className="sum-search">
        <FontAwesomeIcon icon={faMagnifyingGlass} />
        <input
          value={value}
          onChange={(e) => onChange?.(e.target.value)}
          placeholder="Search devices, clients, locations…"
        />
      </div>

      {/* Filter Button */}
      <button
        ref={filterRef}
        className="filter-btn"
        type="button"
        title="Filter"
        onClick={onFilterClick}
      >
        <FontAwesomeIcon icon={faFilter} />
      </button>
    </div>
  );
}